import React from 'react';
import { PropTypes } from 'prop-types';
import { alertType } from 'utils/constants';
import * as icons from 'mdi-material-ui';

const getAlertColorKey = (type, solved) => {
    if (type === alertType.WARNING && !solved) {
        return 'colorWarning';
    } else if (type === alertType.CRITICAL && !solved) {
        return 'colorCritical';
    } else {
        return 'colorSuccess';
    }
};

const SubscriptionAlertCircle = props => {
    const { alertType: type, positionAbsolute, alertSolved, withTopMargin } = props;

    return (
        <icons.Circle
            sx={theme => ({
                fontSize: '16px',
                verticalAlign: 'baseline',
                position: positionAbsolute ? 'absolute' : 'unset',
                mt: withTopMargin ? '4px' : 0,
                color: theme.constants[getAlertColorKey(type, alertSolved)],
            })}
        />
    );
};

SubscriptionAlertCircle.propTypes = {
    alertType: PropTypes.string.isRequired,
    positionAbsolute: PropTypes.bool,
    alertSolved: PropTypes.bool,
    withTopMargin: PropTypes.bool,
};

export default SubscriptionAlertCircle;
